import { Injectable } from "@angular/core";
import { ConfigService } from "./config.service";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class VersionService {
  private readonly VERSION_KEY = "app_version";

  constructor(private configService: ConfigService,
    private _baseService: BaseService
  ) {}

  public initialize(): void {
    this.checkVersion();
  }

  private checkVersion(): void {
    const storedVersion = localStorage.getItem(this.VERSION_KEY);
    const currentVersion = this.configService._config.version;

    if (!storedVersion || this.isNewVersion(storedVersion, currentVersion)) {
      this.showUpdateModal();
    }
  }

  private resetApp(): void {
    // Salva os valores necessários antes de limpar
    const apiUrl = localStorage.getItem("apiUrl");
    const newVersion = this.configService._config.version;

    // Limpa todo o localStorage exceto apiUrl
    localStorage.clear();
    if (apiUrl) {
      localStorage.setItem("apiUrl", apiUrl);
    }
    localStorage.setItem(this.VERSION_KEY, newVersion);

    // Limpa todo o sessionStorage
    sessionStorage.clear();

    // Limpa todos os cookies
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    window.location.reload();
  }

  public checkVersion2(): void {
    const storedVersion = localStorage.getItem(this.VERSION_KEY);
    const currentVersion = this.configService._config.version;

    if (!storedVersion || this.isNewVersion(storedVersion, currentVersion)) {

      this.resetApp()

      // const apiUrl = localStorage.getItem("apiUrl");
      // const newVersion = this.configService._config.version;
      //
      // // Limpa todo o localStorage exceto apiUrl
      // //localStorage.clear();
      // this._baseService.limpaStorage();
      //
      // if (apiUrl) {
      //   localStorage.setItem("apiUrl", apiUrl);
      // }
      // localStorage.setItem(this.VERSION_KEY, newVersion);
      //
      // // Limpa todo o sessionStorage
      // //sessionStorage.clear();
    }
  }

  private isNewVersion(storedVersion: string, currentVersion: string): boolean {
    if (!storedVersion || !currentVersion) {
      return true;
    }

    // Remove -SNAPSHOT e outros sufixos de versão para comparação
    const cleanStoredVersion = storedVersion.replace(/-[A-Za-z]+$/, "");
    const cleanCurrentVersion = currentVersion.replace(/-[A-Za-z]+$/, "");

    const stored = cleanStoredVersion.split(".").map(Number);
    const current = cleanCurrentVersion.split(".").map(Number);

    // Garante que ambas as versões tenham 3 números
    while (stored.length < 3) stored.push(0);
    while (current.length < 3) current.push(0);

    for (let i = 0; i < 3; i++) {
      if (current[i] > stored[i]) {
        return true;
      }
      if (current[i] < stored[i]) {
        return false;
      }
    }
    return false;
  }

  private showUpdateModal(): void {
    const modal = document.createElement("div");
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    `;

    const modalContent = document.createElement("div");
    modalContent.style.cssText = `
      background: white;
      padding: 20px;
      border-radius: 8px;
      text-align: center;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    `;

    const logo = document.createElement("img");
    logo.src =
      "https://www.alianca.com.br/portal/Principal/img/alianca_footer.webp";
    logo.style.cssText = `
      max-width: 150px;
      margin-bottom: 20px;
    `;

    const message = document.createElement("p");
    message.textContent =
      "Existe uma nova versão do App disponível. Clique no botão abaixo para recarregar.";
    message.style.marginBottom = "20px";
    message.style.color = "#333";
    message.style.fontSize = "14px";

    const button = document.createElement("button");
    button.textContent = "Atualizar Agora";
    button.style.cssText = `
      background: #007bff;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      transition: background-color 0.2s;
    `;

    button.onmouseover = () => {
      button.style.backgroundColor = "#0056b3";
    };

    button.onmouseout = () => {
      button.style.backgroundColor = "#007bff";
    };

    button.onclick = () => {
      this.resetApp()
    };

    modalContent.appendChild(logo);
    modalContent.appendChild(message);
    modalContent.appendChild(button);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
  }
}
